import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import WhyChooseSection from '../components/WhyChooseSection';
import PricingSection from '../components/PricingSection';
import ContactForm from '../components/ContactForm';
import FaqSection from '../components/FaqSection';
import Footer from '../components/Footer';
import { siteData } from '../mock';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navbar brandName={siteData.brandName} />
      <Hero hero={siteData.hero} />
      <WhyChooseSection />
      <ServicesSection services={siteData.services} />
      <PricingSection pricing={siteData.pricing} />
      <ContactForm contact={siteData.contact} />
      <FaqSection />
      <Footer brandName={siteData.brandName} contact={siteData.contact} />
    </div>
  );
};

export default Home;
